import { useLocation } from 'react-router';
import queryString, { ParsedQuery } from 'query-string';

// A custom hook that builds on useLocation to parse
// the query string for you.

type QueryValue = string | string[] | null | undefined;

export default function useQuery(): Record<string, QueryValue> {
  const params: ParsedQuery<string> = queryString.parse(useLocation().search);

  const normalized: Record<string, QueryValue> = {};

  for (const key of Object.keys(params)) {
    const value = params[key];
    normalized[key] = value;                 // original key
    normalized[key.toLowerCase()] = value;   // lowercase key
  }

  return normalized;
}